import type { QueryClient } from "@tanstack/react-query"
import {
	getSessionVersion,
	setStoredUserId,
	setTokens,
} from "@/shared/lib/auth"
import type { CheckUserResult } from "../api/client"
import { cacheAuthResult } from "./cache-auth-result"

/**
 * Сохраняет токены, userId под текущую платформу и кладёт ответ
 * в react-query кеш — всё, что нужно сделать после успешного
 * auth-эндпоинта, чтобы следующий __root.beforeLoad увидел юзера.
 */
export async function persistAuthResult(
	queryClient: QueryClient,
	result: CheckUserResult,
	version = getSessionVersion(),
): Promise<void> {
	if (result.exists) {
		await setTokens(result.access_token, result.refresh_token, version)
		await setStoredUserId(result.user.id)
	}

	await cacheAuthResult(queryClient, result)
}
